import React from 'react';
import { View, Text, StyleSheet, Image, ScrollView, Pressable } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { BackgroundGradient, Loader, Button, MFAModal, Storage, Alert } from '../../../components';
import { CountdownTimer } from '../../../components/Projects';
import * as rtApi from '../../../components/Api';
import * as RootNavigation from '../../../utils/RootNavigation';
import { formatCurrency, processLoginAccount } from '../../../utils/Functions';
import UserState from '../../../src/contexts/UserState';
// import * as SecureStore from 'expo-secure-store';
import * as LocalAthentication from 'expo-local-authentication';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const MilestoneScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);

  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [disabledMessage, setDisabledMessage] = React.useState('');
  const [verified, setVerified] = React.useState(false);
  const [verifiedMessage, setVerifiedMessage] = React.useState('');
  const [isCurrentStage, setIsCurrentStage] = React.useState(false);
  const [isFirstFundStage, setIsFirstFundStage] = React.useState(false);
  const [amountAction, setAmountAction] = React.useState('');
  const [deadlinePast, setDeadlinePast] = React.useState(false);
  // const [milestone, setMilestone] = React.useState({});
  const [project, setProject] = React.useState(null);
  const [milestone, setMilestone] = React.useState(null);
  const [isContractor, setIsContractor] = React.useState(false);
  const [isActionRequired, setIsActionRequired] = React.useState(false); // is an action required by this user
  const [alertOptions, setAlertOptions] = React.useState({});

  const stagesWithNoActions = ['Started', 'Invite Sent', 'Completed', 'In-Dispute'];

  const [showMFA, setShowMFA] = React.useState(false);
  const [MFACode, setMFACode] = React.useState(null);
  const [MFATrusted, setMFATrusted] = React.useState(true);
  const [MFARequired, setMFARequired] = React.useState(false);

  const insets = useSafeAreaInsets();

  const linkTo = useLinkTo();

  React.useEffect(() => {
    getUser();
  }, [route.params.milestoneId]);

  React.useEffect(() => {
    return () => rtApi.cancel();
  }, []);

  React.useEffect(() => {
    checkMFACode();
  }, [MFACode]);
  
  React.useEffect(() => {
    console.log('milestone useEffect: ', milestone);
    if(milestone){
      let msg = '';
      if(milestone.completed === 'Yes'){
        msg = milestone.direction === 'Fund' ? `was funded by the homeowner on ${milestone.completed_date}` : `was received by the contractor on ${milestone.completed_date}`;
      }else{
        msg = milestone.direction === 'Fund' ? 'to be funded by the homeowner' : 'to be received by the contractor';
      }
      setAmountAction(msg);
      checkDisableButtons();
      checkIsFirstFundStage();
      checkIsCurrentStage()
      if (milestone.action_required) {
        setIsActionRequired(isContractor ? milestone.direction === 'Release' : milestone.direction === 'Fund');
        console.log('isActionRequired: ', isContractor ? milestone.direction === 'Release' : milestone.direction === 'Fund');
      }
      navigation.setOptions({ title: `Milestone - ${milestone.title}` });
    }
  }, [milestone]);

  const getUser = () => {
    setLoading(true);
    rtApi.get(`users/${user.id}`)
    .then(data => {
      console.log('getUser: ', data);
      let user = processLoginAccount(data.user, false);
      setUser(user);
      getProject();
    }).catch(err => {
      setLoading(false);
      goBack();
    })
  };

  const getProject = () => {
    console.log('getProject', route.params);
    setLoading(true);
    rtApi.get(`agreements/${route.params.projectId}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('got project !', data);
      setProject(data.agreement);
      setIsContractor(data.agreement.contractor_id == user.id);
      setMilestone(data.agreement.stages.filter(s => s.stage_id == route.params.milestoneId)[0]);
    }).catch(err => {
      console.log('milestone getProject catch: ', err);
    }).finally(() => {
      setLoading(false);
    })
  }

  const checkDisableButtons = () => {
    if(user.verified === 'Unverified'){
      setDisabled(true);
      setVerifiedMessage('*Your account must be verified in order to request or release any funds');
      setVerified(false);
      return;
    }else{
      setVerified(true);
    }
    let disabled = false;
    project.stages.forEach(m => {
      if(!m.accepted){
        disabled = true;
        setDisabledMessage(`*There are pending changes that the ${isContractor ? 'homeowner' : 'contractor'} must approve or reject first`);
      }
    });
    setDisabled(disabled);
  }

  const renderButton = () => {
    if (stagesWithNoActions.includes(project.stage) || !isCurrentStage){
      return null;
    }
    console.log('isContractor:', isContractor);
    if(!isContractor){
      // homeowner
      // Fund
      if (milestone.direction === 'Fund' && !milestone.completed && milestone.action_required && project.homeowner_id === user.id){
        return (
          <Button text={isFirstFundStage ? 'Fund This Project' : 'Fund This Milestone'} onPress={() => fundMilestone} disabled={disabled} />
        )
      }
      // Release
      if(milestone.direction === 'Release' && !milestone.completed && isCurrentStage){
        return (
          <Button text='Release funds to Contractor' onPress={() => releaseFunds} disabled={disabled} />
        )
      }
    }else{
      // contractor
      // Release
      if (milestone.direction === 'Release' && !milestone.completed && isCurrentStage && !milestone.due_date && !milestone.active_concern) {
        return (
          <Button text='Request funds from Homeowner' onPress={() => requestFunds} disabled={disabled} />
        )
      }
      //remind
      // if(milestone.direction === 'Fund' && !milestone.completed && isCurrentStage){
      //   return (
      //     <Button text={isFirstFundStage ? 'Remind Customer to Fund This Project' : 'Remind Customer to Fund This Milestone'} onPress={() => remindCustomer} disabled={disabled} />
      //   )
      // }
    }
  }
  const disputeButton = () => {
    if (stagesWithNoActions.includes(project.stage) || deadlinePast || !isCurrentStage) {
      return null;
    }
    if (
      (!isContractor && milestone.direction === 'Release' && !milestone.completed)
      ||
      (isContractor && milestone.direction === 'Return' && !milestone.completed)
      ) {
      return (
        <View style={{ marginTop: 10 }}>
          <Button text='File a Dispute' onPress={() => fileDispute} color='red' disabled={disabled} />
        </View>
      )
    }
  }

  const concernButton = () => {
    if (stagesWithNoActions.includes(project.stage) || deadlinePast || milestone.active_concern || !isCurrentStage) {
      return null;
    }
    if (milestone.action_required === user.freshdesk_id) {
      return (
        <View style={{ marginTop: 10 }}>
          <Button text='Raise a Concern' onPress={() => raiseConcern} color='blue' disabled={disabled} />
        </View>
      )
    }
  }

  const remindButton = () => {
    if (stagesWithNoActions.includes(project.stage) || deadlinePast || milestone.active_concern || !isCurrentStage) {
      return null;
    }
    if (isContractor && milestone.direction === 'Fund' && (!milestone.completed || milestone.completed === 'No') && milestone.remind_to_fund) {
      return (
        <View style={{ marginTop: 10 }}>
          <Button text='Remind Homeowner To Fund' onPress={() => remindHomeownerToFund} color='blue' disabled={disabled} />
        </View>
      )
    }
  }

  // fund milestone
  const fundMilestone = () => {
    linkTo(`/project/${route.params.projectId}/milestone/${route.params.milestoneId}/method/${project.accept_credit_cards}`);
    // RootNavigation.navigate('PaymentMethod', {
    //   milestone: milestone,
    //   projectId: project.id,
    //   acceptCreditCards: project.accept_credit_cards,
    //   whoPays: project.who_pays,
    // });
  }

  // release funds
  const releaseFunds = async () => {
    console.log('releaseFunds()');
    // let useLocalAuthentication = await SecureStore.getItemAsync('useLocalAuthentication');
    let useLocalAuthentication = await Storage.getItem('useLocalAuthentication');
    console.log('useLocalAuthentication: ', useLocalAuthentication);
    if (useLocalAuthentication === 'yes') {
      releaseUsingLocalAuthentication();
      // releaseTriggerMFA(); // testing
    } else {
      releaseTriggerMFA();
    }
  }
  const releaseUsingLocalAuthentication = async () => {
    console.log('payUsingLocalAuthentication');
    let authenticateAsync = await LocalAthentication.authenticateAsync({
      promptMessage: 'Release the funds to the Contractor'
    });
    console.log('authenticateAsync', authenticateAsync);
    if (authenticateAsync.success) {
      console.log('success!')
      let releaseResult = await releaseFund(false);
      if (releaseResult.result) {
        // successAlert("The funds will be released to the Contractor");
        successAlert("We'll let your contractor know you've released the funds for this milestone.");
      }
    }
  }
  const releaseTriggerMFA = async () => {
    // trigger mfa code generation
    let releaseResult = await releaseFund();
    console.log('releaseResult: ', releaseResult);
    if (releaseResult.result && releaseResult.MFA) {
      // successAlert("The amount will be funded instantly from your account balance");
      setMFARequired(true);
      setShowMFA(true);
    }
  }
  const checkMFACode = () => {
    console.log('MFACode', MFACode);
    if (String(MFACode).length === 6) {
      setShowMFA(false);
      if (MFARequired) {
        console.log('use the mfa code: ', MFACode);
        releaseUsingMfa();
      }
    }
  }
  const releaseUsingMfa = async () => {
    let releaseResult = await releaseFund(MFACode);
    if (releaseResult.result) {
      successAlert("We'll let your contractor know you've released the funds for this milestone.");
    }
  }
  const releaseFund = (mfa) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      let fd = new FormData();
      if (mfa !== undefined) {
        fd.append('MFA', mfa);
      }
      rtApi.post(`agreements/${route.params.projectId}/stages/${milestone.stage_id}/release-money`, fd)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        console.log('postFund: ', data);
        setLoading(false);
        resolve(data);
      })
      .catch(err => {
        setLoading(false);
        reject(err);
      });
    });
  }
  const successAlert = (message) => {
    console.log('successAlert message: ', message);
    setTimeout(() => {
      setAlertOptions({
        visible: true,
        title: 'Success',
        message: message,
        buttons: [
          {
            text: 'OK',
            onPress: () => goBackToProjects()
          }
        ]
      })
    }, 100);
  }
  const goBackToProjects = () => {
    // route.params.milestoneId = null;
    linkTo('/projects');
  }
  const checkIsCurrentStage = () => {
    // let index = getStageIndex();
    let currentStage = project.stages.find(s => s.completed === undefined);
    // console.log('stageIndex: ', index, currentStage);
    console.log('isCurrentStage: ', currentStage.stage_id === milestone.stage_id);
    setIsCurrentStage(currentStage.stage_id === milestone.stage_id);
    // if (
    //   (index !== -1 && index !== 0 && project.stages[index - 1].completed && project.stages[index - 1].completed === 'Yes')
    //   ||
    //   (index === 0 && milestone.completed === undefined)
    // ){
    //   console.log('isCurrentStage: true');
    //   setIsCurrentStage(true);
    // }else{
    //   console.log('isCurrentStage: false');
    //   setIsCurrentStage(false);
    // }
  }
  const getStageIndex = () => {
    for (let i = 0; i < project.stages.length; i++) {
      if (milestone.stage_id === project.stages[i].stage_id) {
        return i;
        break;
      }
    }
    return -1;
  }
  const checkIsFirstFundStage = () => {
    let stageId = null;
    project.stages.forEach(s => {
      if(!stageId && s.direction === 'Fund'){
        stageId = s.stage_id;
      }
    });
    setIsFirstFundStage(stageId === milestone.stage_id ? true : false);
  }

  // request funds
  const requestFunds = () => {
    console.log('requestFunds()');
    setLoading(true);
    rtApi.get(`agreements/${project.id}/stages/${milestone.stage_id}/request-money`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('requestFunds data: ', data);
      // getProject();
      // goBackToProjects();
      successAlert("We'll let your customer know you've requested them to release funds for this milestone.")
    })
    .catch(err => {
      console.log('requestFunds catch: ', err);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  // file a dispute
  const fileDispute = () => {
    console.log('fileDispute');
    // linkTo(`/howdisputeswork/${milestone.stage_id}`);
    linkTo(`/howdisputeswork/${route.params.projectId}`);
  }

  // remind homeowner to fund
  const remindHomeownerToFund = () => {
    console.log('remindHomeownerToFund()');
    setLoading(true);
    rtApi.get(`agreements/${project.id}/stages/${milestone.stage_id}/request-funding`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('remindHomeownerToFund data: ', data);
      // getProject();
      // goBackToProjects();
      successAlert("We'll let your customer know you've requested them to fund this milestone.")
    })
    .catch(err => {
      console.log('remindHomeownerToFund catch: ', err);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  //remind customer
  // const remindCustomer = () => {
  //   console.log('remindCustomer()');
  //   setLoading(true);
  //   rtApi.get(`agreements/${route.params.projectId}/stages/${route.params.milestone.stage_id}/remind-customer`)
  //   .then(data => {
  //     console.log('remindCustomer data: ', data);
  //     goBackToProjects()
  //   })
  //   .catch(err => {
  //     console.log('remindCustomer catch: ', err);
  //   })
  //   .finally(() => {
  //     setLoading(false);
  //   });
  // }

  const cancelMFA = () => {
    setShowMFA(false);
    setMFACode(null);
    setMFARequired(false);
  }

  // raise a concern
  const raiseConcern = () => {
    console.log('raiseCorcern()');
    setLoading(true);
    rtApi.post(`agreements/${project.id}/stages/${milestone.stage_id}/raise-concern`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('raiseCorcern data: ', data);
      goBackToProjects();
    })
    .catch(err => {
      console.log('raiseCorcern catch: ', err);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  // concede
  const concede = () => {
    console.log('concede()');
    setLoading(true);
    rtApi.put(`agreements/${project.id}/stages/${milestone.stage_id}/raise-concern`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('concede data: ', data);
      goBackToProjects();
    })
    .catch(err => {
      console.log('concede catch: ', err);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  const goToAccount = () => {
    linkTo('/profile?verify=yes');
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      console.log('canGoBack')
      navigation.goBack();
    } else {
      console.log('!canGoBack')
      // linkTo(`/project/${project.id}`);
      linkTo(`/project/${route.params.projectId}`);
    }
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <MFAModal
        show={showMFA}
        cancel={cancelMFA}
        setMFACode={setMFACode}
        setMFATrusted={setMFATrusted}
        showTrusted={false}
        MFATrusted={MFATrusted}
      />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      {milestone &&
      <View style={CS.innerContainer}>
        
        {/* screen content */}
        <ScrollView contentContainerStyle={{ paddingTop: insets.top, paddingBottom: insets.bottom }}>
          <Pressable onPress={goBack} style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0, marginVertical: 10 }]} hitSlop={10}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </Pressable>
          {(!milestone.completed && milestone.due_date) &&
            <CountdownTimer date={milestone.due_date} freshdeskId={milestone.action_required} setDeadlinePast={setDeadlinePast} type='milestone' />
            // <CountdownTimer date='2021-03-03T00:00:00Z' freshdeskId={route.params.milestone.freshdesk_id} />
          }
          <Text style={[CS.mediumTitle, CS.lightText, { marginBottom: 5 }]}>{milestone.title}</Text>
          <Text style={[CS.smallText, CS.lightBlueText]}>{formatCurrency(milestone.amount)} {amountAction}</Text>
          <View style={{ marginTop: 20 }}>
            {renderButton()}
            {disputeButton()}
            {concernButton()}
            {remindButton()}
            {(disabled && isActionRequired) &&
              <Text style={[CS.miniText, CS.redText, { marginVertical: 10 }]}>{disabledMessage}</Text>
            }
            {milestone.memo ? 
              <Text style={[CS.smallText, CS.lightBlueText, { marginVertical: 10 }]}>{milestone.memo}</Text>
            : null}
            {!verified && verifiedMessage ?
              <>
                <Text style={[CS.miniText, CS.redText, { marginVertical: 5 }]}>{verifiedMessage}</Text>
                <Button text='Verify Your Account Now' onPress={() => goToAccount} />
              </>
              : null
            }
          </View>
          <Text style={[CS.smallTitle, CS.lightText, { marginBottom: 5 }]}>Scope of Work</Text>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{milestone.description || 'No scope of work has been entered for this milestone'}</Text>
        </ScrollView>
      </View>
      }
    </View>
  );

}

const styles = StyleSheet.create({
  
});

export default MilestoneScreen;